import { PhoneNumberUtil } from 'google-libphonenumber';
import type { TFunction } from 'i18next';
import { string } from 'yup';

const phoneUtil = PhoneNumberUtil.getInstance();

const make = (
  t: TFunction,
  requiredToken: string = 'mobilePhoneIsRequired',
  validToken: string = 'pleaseProvideAValidPhoneNumber',
) =>
  string()
    .required(t(requiredToken))
    .test('mobilePhone', t(validToken), rawNumber => {
      const raw = rawNumber || '';

      // Check if the phone contains any characters other than the allowed list
      if (/[^+-.()\d ]/.exec(raw)) {
        return false;
      }

      const matches = raw.match(/([+])/g);

      if (matches && matches.length > 1) {
        return false;
      }

      try {
        const phone = phoneUtil.parse(raw);

        return phoneUtil.isValidNumber(phone);
      } catch (_parseError) {
        // do nothing because we want to try again
      }

      try {
        const northAmericaPhone = phoneUtil.parse(`+1${raw}`);

        return phoneUtil.isValidNumber(northAmericaPhone);
      } catch (_northAmericanParseError) {
        return false;
      }
    });

export { make };
